import { usePage } from "@inertiajs/react"

import { NavItem } from "@/components/secondary-nav"
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from "@/components/ui/sheet"
import { useFilteredItems } from "@/hooks/use-filtered-nav"
import { detectSection, isActiveLink, isGroup, sections } from "@/lib/nav-data"

export function MobileDrawer({
  open,
  onOpenChange,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
}) {
  const { url } = usePage()
  const currentPath = url.split("?")[0]
  const currentUrl = url
  const sectionKey = detectSection(currentPath)
  const section = sections[sectionKey]
  const displayItems = useFilteredItems(sectionKey, section?.items ?? [])

  if (!section) return null

  const closeDrawer = () => onOpenChange(false)

  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent side="left" className="w-[260px] p-0 sm:max-w-[260px]">
        <SheetHeader className="border-hpi-light-gray border-b px-5 pt-5 pb-3">
          <SheetTitle className="text-hpi-dark-blue text-lg font-medium">
            {section.title}
          </SheetTitle>
        </SheetHeader>

        <div className="flex flex-col gap-0.5 overflow-y-auto px-3 py-3">
          {displayItems.map((entry) =>
            isGroup(entry) ? (
              <div key={entry.label} className="mt-2">
                <div className="text-hpi-dark-blue px-2 pb-1 text-[13px] font-medium">
                  {entry.label}
                </div>
                <div className="flex flex-col gap-0.5 pl-2">
                  {entry.children.map((child) => (
                    <NavItem
                      key={child.label}
                      label={child.label}
                      href={child.href}
                      active={isActiveLink(child.href, currentUrl)}
                      onClick={closeDrawer}
                    />
                  ))}
                </div>
              </div>
            ) : (
              <NavItem
                key={entry.label}
                label={entry.label}
                href={entry.href}
                active={isActiveLink(entry.href, currentUrl)}
                onClick={closeDrawer}
              />
            ),
          )}
        </div>
      </SheetContent>
    </Sheet>
  )
}
